const navs = [
    { name: "configuration.groups-profiles", url: "/device-configuration/groups-profiles/", icon: "gear", role: "admin" },
    { name: "configuration.measures", url: "/device-configuration/measures/", icon: "wrench", role: "admin" },
    { name: "configuration.sensors", url: "/device-configuration/sensors/", icon: "fa-wifi", className: "fa-rotate-180", role: "admin" },
    { name: "configuration.alerts", url: "/device-configuration/alerts/", icon: "fa-regular fa-bell", role: "admin" },
    { name: "labels.send", url: "/device-configuration/shipping/", icon: "fa-regular fa-paper-plane", role: "admin" },
]
export default navs